module.exports = __webpack_public_path__ + "img/logo-icon.71c06cbc.png";